import * as ALOOMA from 'consts/alooma';
import { PATHS } from 'consts/paths';

function matchBssPathWithAloomaSource(path) {
  switch (path) {
    case PATHS.BSS_COUPON_CODES:
      return ALOOMA.SOURCE_PAGES.BSS_COUPON_CODES;

    case PATHS.BSS_COUPON_CODES_SEASONAL_BF:
      return ALOOMA.SOURCE_PAGES.BSS_COUPON_CODES_SEASONAL_BF;

    case PATHS.BSS_TOOLS_PRICE_TRACKER:
      return ALOOMA.SOURCE_PAGES.BSS_TOOLS_PRICE_TRACKER;

    case PATHS.BSS_TOOLS_DISCOUNT_CALC:
      return ALOOMA.SOURCE_PAGES.BSS_TOOLS_DISCOUNT_CALC;

    case PATHS.BSS_ALTERNATIVES:
      return ALOOMA.SOURCE_PAGES.BSS_ALTERNATIVES;

    case PATHS.BSS_ALTERNATIVES_COUPERT:
      return ALOOMA.SOURCE_PAGES.BSS_ALTERNATIVES_COUPERT;

    default:
      return '';
  }
}

export default matchBssPathWithAloomaSource;
